/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import TwoFactorUpgradeBaseComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/upgrade/base';
let TwoFactorModalUpgradeBaseComponent = (_dec = service('ember-multipass-logging'), _class = class TwoFactorModalUpgradeBaseComponent extends TwoFactorUpgradeBaseComponent {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "logger", _descriptor, this);
    this.logger.addComponentBreadcrumb('TwoFactorModalUpgradeBaseComponent');
  }

  // override TwoFactorUpgradeBaseComponent#hideUseAnotherMethodButton with email-less version
  // the normal version is used in login and has email 2fa as fallback, but modal does not have the use case
  get hideUseAnotherMethodButton() {
    if (this.multipassfeClient.twoFactorDetails.filter(x => !x.email).length > 1) {
      return false;
    }
    if (this.isSmsMethod && this.multipassfeClient.canUseVoice) {
      return false;
    }
    return true;
  }

  /**
   * Override TwoFactorUpgradeBaseComponent#handleMultipassError w/ two_factor_modal copy
   */
  handleMultipassError(error) {
    switch (error.message) {
      case 'BLOCKED_SMS_NUMBER':
        this.smsBlockedOptInMessagingModalOpen = true;
        break;
      case 'INVALID_ALIAS':
      case 'INVALID_CREDENTIALS':
        this.error = this.intl.t(this.tPrefix + 'two_factor_modals.upgrade.generic.errors.invalid_verification_code');
        break;
      case 'TEMPORARY_LOCKOUT':
        this.error = this.intl.t(this.tPrefix + 'two_factor_modals.upgrade.generic.errors.temporary_lockout');
        break;
      default:
        this.logger.sentryError(error);
        this.error = this.intl.t(this.tPrefix + 'two_factor_modals.upgrade.generic.errors.unknown');
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TwoFactorModalUpgradeBaseComponent as default };